//All Types of Branch Transfer Receive
export const DISPATCH_FROM_BRANCH="DISPATCH_FROM_BRANCH";
export const Dispatch_SELECT_VEHICLE="Dispatch_SELECT_VEHICLE";
export const Dispatch_SHOWLIST_DATA="Dispatch_SHOWLIST_DATA"
export const Dispatch_RECEIVE="Dispatch_RECEIVE"
export const Dispatch_SHORT_RECEIVE="Dispatch_SHORT_RECEIVE"
export const Dispatch_RECEIVE_ITEMLIST="Dispatch_RECEIVE_ITEMLIST"
export const BRANCHRECEIVE_LASTRECEIVE_PRINT="BRANCHRECEIVE_LASTRECEIVE_PRINT"


//All Types of  Receive
export const RECEIVE_DISPATCH_FROM_CITY="RECEIVE_DISPATCH_FROM_CITY";
export const RECEIVE_DISPATCH_FROM_CITY_TWO="RECEIVE_DISPATCH_FROM_CITY_TWO";
export const RECEIVE_DISPATCH_SELECT_VEHICLE="RECEIVE_DISPATCH_SELECT_VEHICLE";
export const RECEIVE_DISPATCH_LOAD_VEHICLE="RECEIVE_DISPATCH_LOAD_VEHICLE";
export const RECEIVE_DISPATCH_CHALLAN_NO="RECEIVE_DISPATCH_CHALLAN_NO";
export const RECEIVE_LASTRECEIVE_PRINT="RECEIVE_LASTRECEIVE_PRINT"
export const DISPATCH_RECEIVE_SHOWLIST_DATA="DISPATCH_RECEIVE_SHOWLIST_DATA";
export const Dispatch_RECEIVE_RECEIVE="Dispatch_RECEIVE_RECEIVE"
export const Dispatch_RECEIVE_DATALIST="Dispatch_RECEIVE_DATALIST"
export const Dispatch_RECEIVE_LRLIST="Dispatch_RECEIVE_LRLIST"
export const Dispatch_RECEIVE_LUGGAGETORECEIVE="Dispatch_RECEIVE_LUGGAGETORECEIVE"
export const Dispatch_RECEIVE_SECOND="Dispatch_RECEIVE_SECOND"





